export interface RootsData {
    code: number;

    message: string;

    roots: Array<{
        id: number
        name: string
    }>;
}
